/**
 * Detecta la estación actual en Chile según la fecha
 * @returns {string} Nombre de la estación ('verano', 'otono', 'invierno', 'primavera')
 */
export const getCurrentSeason = () => {
  const now = new Date();
  const month = now.getMonth() + 1; // getMonth() devuelve 0-11

  // Estaciones para el hemisferio sur (Chile)
  if (month >= 12 || month <= 3) {
    return 'verano';
  } else if (month >= 3 && month <= 6) {
    return 'otono';
  } else if (month >= 6 && month <= 9) {
    return 'invierno';
  } else {
    return 'primavera';
  }
};

/**
 * Obtiene la clase CSS según la estación actual
 * @returns {string} Clase CSS ('season-verano', 'season-otono', etc.)
 */
export const getSeasonClass = () => {
  return `season-${getCurrentSeason()}`;
};

/**
 * Obtiene un objeto con información detallada sobre la estación actual
 * @returns {Object} Información de la estación actual
 */
export const getSeasonInfo = () => {
  const season = getCurrentSeason();
  
  const seasonInfo = {
    verano: {
      name: 'Verano',
      description: 'Temporada de calor y vacaciones',
      icon: '☀️',
      message: '¡Disfruta del sol y nuestras actividades de verano!'
    },
    otono: {
      name: 'Otoño',
      description: 'Temporada de colores y clima templado',
      icon: '🍂',
      message: '¡Disfruta de los hermosos paisajes otoñales!'
    },
    invierno: {
      name: 'Invierno',
      description: 'Temporada de frío y nieve en la cordillera',
      icon: '❄️',
      message: '¡Ven a disfrutar del ambiente acogedor de nuestro hostal!'
    },
    primavera: {
      name: 'Primavera',
      description: 'Temporada de flores y renovación',
      icon: '🌸',
      message: '¡La naturaleza despierta! Ideal para actividades al aire libre.'
    }
  };
  
  return seasonInfo[season];
}; 